import React from 'react';


const ColorSchemaPreviewRegularStore = ({colorSchema}) => {
  const colorsToPreview = {
    headerTopBgColor: colorSchema.header['theme_design/header/top_border_color'],
    headerBgColor: colorSchema.header['theme_design/header/header_bg_color'],
    headerColor: colorSchema.header['theme_design/header_primary/text_color'],
    buttonBgColor: colorSchema.buttons['theme_design/colors/button_bg_color'],
    buttonColor: colorSchema.buttons['theme_design/colors/button_color'],
    menuBgColor: colorSchema.menu['theme_design/nav/outer_menu_bg_color'],
    menuColor: colorSchema.menu['theme_design/nav/color'],
    tabBgColor: colorSchema.product_page['theme_design/product_page/product_tabs_bg_color'],
    tabColor: colorSchema.product_page['theme_design/product_page/product_tabs_color'],
    tabBgColorActive: colorSchema.product_page['theme_design/product_page/product_tabs_bg_color_active'],
    tabColorActive: colorSchema.product_page['theme_design/product_page/product_tabs_color_active'],
    productNameColor: colorSchema.category_page['theme_design/colors/product_name_color'],
    productPriceColor: colorSchema.category_page['theme_design/colors/price_color'],
    taglineBgColor: colorSchema.footer['theme_design/footer_tagline/bg_color'],
    taglineColor: colorSchema.footer['theme_design/footer_tagline/color'],
    footerBgColor: colorSchema.footer['theme_design/footer/bg_color'],
    footerColor: colorSchema.footer['theme_design/footer/color'],
    footerBottomBgColor: colorSchema.footer['theme_design/footer_bottom/bg_color'],
    footerBottomColor: colorSchema.footer['theme_design/footer_bottom/color']
  };

  const {
    headerTopBgColor,
    headerBgColor,
    headerColor,
    buttonBgColor,
    buttonColor,
    menuBgColor,
    menuColor,
    tabBgColor,
    tabColor,
    tabBgColorActive,
    tabColorActive,
    productNameColor,
    productPriceColor,
    taglineBgColor,
    taglineColor,
    footerBgColor,
    footerColor,
    footerBottomBgColor,
    footerBottomColor
  } = colorsToPreview;

  return (
    <div>
      <div className="min-h-8" style={{backgroundColor: `${headerTopBgColor}`}} />
      <div className="flex items-center justify-evenly py-8" style={{backgroundColor: `${headerBgColor}`}}>
        <div className="uppercase w-full text-center text-24" style={{color: `${headerColor}`}}>logo</div>
        <div className="w-full">
          <div className="min-h-8 mx-auto max-w-100" style={{backgroundColor: `${headerColor}`}} />
          <div className="min-h-20 max-w-80full mx-6 bg-white mt-2" style={{border: '1px solid #c2c2c2'}} />
        </div>
        <div className="w-full flex-column justify-end px-4">
          <div className="min-h-8 ml-4" style={{backgroundColor: `${headerColor}`}} />
          <div className="min-h-8 w-full max-w-40 mt-2 mb-3" style={{backgroundColor: `${headerColor}`, alignSelf: 'end'}} />
        </div>
      </div>
      <div className="flex items-center justify-center px-2 py-4"  style={{backgroundColor: `${menuBgColor}`}}>
        <div className="flex items-center justify-between w-full max-w-400">
          <div className="min-w-60 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-80 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
          <div className="min-w-40 min-h-4" style={{backgroundColor: `${menuColor}`}} />
        </div>
      </div>
      <div
        className="flex-column items-center justify-center max-w-80full w-full m-auto px-8 mt-10"
        style={{borderBottom: '1px solid rgb(204, 204, 204)'}}
      >
        <div className="flex items-center justify-center w-full">
          <div
            className="w-full max-w-100 min-h-30 flex items-center justify-center border-1-white"
            style={{backgroundColor: `${tabBgColor}`, marginBottom: '-1px'}}
          >
            <div className="min-h-4 max-w-60 w-full" style={{backgroundColor: `${tabColor}`}} />
          </div>
          <div
            className="w-full max-w-100 min-h-30 flex items-center justify-center border-1-white"
            style={{backgroundColor: `${tabBgColorActive}`, marginBottom: '-1px'}}
          >
            <div className="min-h-4 max-w-60 w-full" style={{backgroundColor: `${tabColorActive}`}} />
          </div>
          <div
            className="w-full max-w-100 min-h-30 flex items-center justify-center border-1-white"
            style={{backgroundColor: `${tabBgColor}`, marginBottom: '-1px'}}
          >
            <div className="min-h-4 max-w-60 w-full" style={{backgroundColor: `${tabColor}`}} />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-evenly flex-wrap mt-5 mb-10 mx-auto x-full max-w-80full">
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
        <div className="flex-column p-3 items-center">
          <div className="w-full min-w-60 min-h-60 mb-3 bg-gray" />
          <div className="w-full max-w-60 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-80full min-h-4 mx-auto mb-2" style={{backgroundColor: `${productNameColor}`}} />
          <div className="w-full max-w-24 min-h-4 mx-auto mb-2" style={{backgroundColor: `${productPriceColor}`}} />
          <div className="w-full max-w-100 flex justify-center border-radius-8 my-4" style={{backgroundColor: `${buttonBgColor}`}}>
            <div className="w-full min-h-4 max-w-40 mx-4 my-3" style={{backgroundColor: `${buttonColor}`}} />
          </div>
        </div>
      </div>
      <div className="w-full min-h-28 flex items-center" style={{backgroundColor: `${taglineBgColor}`}}>
        <div className="flex items-center justify-between w-full max-w-80full mx-auto">
          <div className="flex items-center w-full max-w-80full">
            <div className="w-full w-20 min-h-4 mx-1" style={{backgroundColor: `${taglineColor}`}} />
            <div className="w-full w-20 min-h-4 mx-1" style={{backgroundColor: `${taglineColor}`}} />
            <div className="w-full w-20 min-h-4 mx-1" style={{backgroundColor: `${taglineColor}`}} />
            <div className="w-full w-20 min-h-4 mx-1" style={{backgroundColor: `${taglineColor}`}} />
          </div>
          <div className="w-full max-w-200 min-h-4" style={{backgroundColor: `${taglineColor}`}} />
        </div>
      </div>
      <div className="w-full pt-8 pb-2" style={{backgroundColor: `${footerBgColor}`}}>
        <div className="max-w-80full w-full mx-auto px-1">
          <div className="flex items-center w-full mb-6">
            <div className="w-full max-w-24 min-h-24 mr-2 rounded" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full max-w-24 min-h-24 mr-2 rounded" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full max-w-24 min-h-24 mr-2 rounded" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full max-w-24 min-h-24 mr-2 rounded" style={{backgroundColor: `${footerColor}`}} />
          </div>
          <div className="flex items-center justify-evenly w-full mb-3">
            <div className="w-full min-h-4 mr-8" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full min-h-4 mr-8" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full min-h-4 mr-8" style={{backgroundColor: `${footerColor}`}} />
            <div className="w-full min-h-4 mr-8" style={{backgroundColor: `${footerColor}`}} />
          </div>
          <div className="flex items-center justify-evenly w-full mb-4">
            <div className="flex-column mr-8 w-full">
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
            <div className="flex-column mr-8 w-full">
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
            <div className="flex-column mr-8 w-full">
              <div className="flex items-center mb-6 mr-2">
                <div className="w-full min-h-24 mr-4 bg-gray" />
                <div className="w-full min-h-24 bg-gray" />
              </div>
            </div>
            <div className="flex-column mr-8 w-full">
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-full min-h-4 ml-3" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-4 h-4 rounded mr-2" style={{backgroundColor: `${footerColor}`}} />
                <div className="w-full min-h-4" style={{backgroundColor: `${footerColor}`}} />
              </div>
              <div className="flex items-center mb-2 mr-2">
                <div className="w-full min-h-4 ml-3" style={{backgroundColor: `${footerColor}`}} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="min-h-28" style={{backgroundColor: `${footerBottomBgColor}`}}>
        <div className="w-full max-w-80full mx-auto min-h-28 flex items-center">
          <div className="w-full max-w-200 min-h-4" style={{backgroundColor: `${footerBottomColor}`}} />
        </div>
      </div>
    </div>
  );
};

export default ColorSchemaPreviewRegularStore;
